import React from 'react';
import { Panel, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ui from '../../common/services/ui';
import { faEye, faPenToSquare } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, onDelete, onEdit, ...rest }) => {

	const renderActions = (id) => {
		return (
			<div>
				<Link to={`/workshops/${id}`} disabled={isReadonly} className='btn btn-teal' style={{ marginBottom: '10px' }}>
					<FontAwesomeIcon icon={isReadonly ? faEye : faPenToSquare} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}
				</Link>
			</div>
		);
	}

	const columns = [
		{
			header: t('Workshop_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Workshop_Center'),
			accessor: 'centerName',
			sortable: true
		},
		{
			header: t('Workshop_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate))
		},
		{
			header: t('Workshop_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => (ui.formatDate(endDate))
		},
		{
			header: t('Workshop_AllowBooking'),
			accessor: 'allowBooking',
			sortable: true,
			cell: (allowBooking, row) => <span>
				{ui.formatBoolean(allowBooking)}
				{row.hidden && <Label bsStyle='info' style={{ marginLeft: 3 }}>{t('Workshop_Hidden')}</Label>}
			</span>
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => renderActions(id)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/workshops/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default List;